import React from 'react';
import { useQuery } from '@apollo/client';
import { Container, Typography, CircularProgress } from '@mui/material';
import { GET_LISTINGS } from '../../../graphql/queries';
import ListingsTable from './ListingTable';

const MyListings: React.FC = () => {
  const { loading, error, data } = useQuery(GET_LISTINGS);

  if (loading) return <CircularProgress data-testid="loading-spinner" />;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <Container maxWidth="lg">
      <Typography variant="h4" gutterBottom>
        My Listings
      </Typography>
      <ListingsTable listings={data.listings} />
    </Container>
  );
};

export default MyListings;
